$(document).ready(function () {
    const guaranteeButton = $('#guarantee_button');
    const refreshButton = $('#refresh_button');
    const refreshButtonError = $('#refresh_error_button');
    const errorMessages = $('#error_messages ul');

    function animateLoading() {
        const loadingMessage = document.getElementById("loading_message");
        let dots = 0;

        return setInterval(() => {
            dots = (dots + 1) % 4; // Cycle through 0, 1, 2, 3
            loadingMessage.textContent = "Submitting" + ".".repeat(dots);
        }, 500); // Adjust the time interval as needed (500ms for half-second intervals)
    }

    const loadingInterval = animateLoading();

    guaranteeButton.on('click', function (e) {
        e.preventDefault(); // Prevent the form from submitting via a link

        // Get the form input values
        const guaranteeID = $('#guarantee_order_id').val();
        const deliveryPostcode = $('#guaranteeDelivery').val();
        const guaranteeEmail = $('#guaranteeBillingEmail').val();
        const clientApiKey = 'jkngf8u9743ntdRAHfgsu980t56u8';

        // Get the value of the checkbox
        const exclusiveOffers = $('#exclusiveOffers').is(':checked');

        // Clear previous error messages and hide the error container
        errorMessages.empty();
        $('#error_messages').hide();

        // Show the loading message
        $('#loading_message').show();
        guaranteeButton.css({
            'opacity': 0.8,
            'pointer-events': 'none'
        });
        $('#submit_default').hide();


        // Validate the form input fields
        let hasErrors = false;

        if (!guaranteeID || !deliveryPostcode || !guaranteeEmail) {
            appendErrorMessage('Please complete all fields');
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }

        if (!isValidEmail(guaranteeEmail)) {
            appendErrorMessage('Please enter a valid email address');
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }
        if (guaranteeEmail.length > 320) {
            appendErrorMessage('Email address is too long. Maximum length is 320 characters.');
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }
        if (deliveryPostcode.length > 15) {
            appendErrorMessage('Delivery postcode is too long. Maximum length is 15 characters.');
            hasErrors = true;

            $('#loading_message').hide();
            $('#submit_default').show();
            guaranteeButton.css({
                'opacity': 1,
                'pointer-events': 'auto'
            });
        }

        if (!hasErrors) {
            // Prepare the data to be sent in the POST request
            const requestData = {
                order_number: guaranteeID,
                town_or_postcode: deliveryPostcode,
                email: guaranteeEmail,
                phone: null,
                marketing_consent: exclusiveOffers
            };

            // Make a POST request to the microservice API
            fetch(`https://app-lj-shipping-charges.azurewebsites.net/SalesOrder/GuarenteeRegistration/${clientApiKey}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            })
                .then(handleResponse)
                .then(data => handleSuccess(data))
                .catch(handleError);
        }
    });


    // Event listener for the refresh button
    refreshButton.on('click', function () {
        location.reload();
    });

    refreshButtonError.on('click', function () {
        location.reload();
    });

    // Function to validate email format
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function appendErrorMessage(message) {
        const errorMessage = `<li>${message}</li>`;
        errorMessages.append(errorMessage);

        if (errorMessages.children().length > 0) {
            $('#error_messages').show();
        } else {
            $('#error_messages').hide();
        }
    }

    // Function to handle the response from the API
    function handleResponse(response) {
        console.log('response::', response)
        if (response.status === 200) {
            return response.json(); // Parse the response JSON for success
        } else if (response.status === 401) {
            appendErrorMessage('Unauthorized: Invalid client API key');
            throw new Error('Unauthorized');
        } else if (response.status === 422) {
            return response.json().then(data => {
                if (data.errors && data.errors.length > 0) {
                    const errorMessages = data.errors.map(error => error.errorMessage).join('\n');

                    console.log(errorMessages);
                    $('.error_container_text').text(errorMessages);
                    $('.error_container_text').show();

                    $('#error_container').show();
                    $('#form_container').hide();
                    $('#success_container').hide();
                    $('#error_messages').hide();
                    $('.guarantee_heading').hide();

                } else {
                    $('#success_container').show();
                    $('#form_container').hide();
                    $('#error_container').hide();
                    $('#error_messages').hide();
                    $('.guarantee_heading').hide();
                }
                throw new Error('Validation Errors');
            });
        } else if (response.status === 404) {
            appendErrorMessage('The order could not be found or has nothing fulfilled. Please try again or contact customer service.');
            throw new Error('Order Not Found');
        } else if (response.status === 400) {
            appendErrorMessage('Your order is outside the allowed registration time.');
            throw new Error('Order Registration Time Error');
        } else {
            // Handle other response statuses here
            appendErrorMessage('Technical error: An error occurred while processing the request.');
            throw new Error('Request Failed');
        }
    }

    function handleSuccess(data) {
        console.log('Success:', data);
        // Hide the form container and success container
        $('#form_container').hide();
        $('#success_container').show();
        $('#loading_message').hide();
        $('#submit_default').show();
        $('.guarantee_heading').hide();
        guaranteeButton.css({
            'opacity': 1,
            'pointer-events': 'auto'
        });
    }

    // Function to handle errors
    function handleError(error) {
        // Handle network or other errors
        console.error(error);

        $('#loading_message').hide();
        $('#submit_default').show();
        guaranteeButton.css({
            'opacity': 1,
            'pointer-events': 'auto'
        });

        // Handle errors and show the error container
        $('#error_messages').show();
    }
});

